import PlateWell from './PlateWell';
import { useState } from 'react';
import _ from 'lodash';
import html2canvas from 'html2canvas';
const alpha = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

const GRID_DOM_ID = "plate-grid";



export default function PlateGrid({
 
  showHeadings=true,
  showText=true,
  grid,experiment, gridId,
  setHover, hoverMap={}, onClick,
  
}){


  let usesBySub = _.groupBy(
    grid.flat().flat(), 
    item => item.substance
  );


  let valsBySubMap = Object.fromEntries(Object.entries(usesBySub).map(([subId,uses]) => {

    let range = Array.from(new Set(
      uses.map(use => use.value)
    )).sort();


    let rMin = range[0];
    let rMax = range[range.length-1];

    let logRange = Math.log(rMax/rMin);


    let opacityMap = {};

    range.forEach(value => {

      if( logRange > 3 ){

      let val = Math.min(value+5,rMax);
      opacityMap[value] = Math.log(val/rMin) / Math.log(rMax/rMin);
    }else{
      let val = Math.min(value + 0.1*(rMax-rMin), rMax);
      opacityMap[value] = (val-rMin) / (rMax-rMin);
    }
    })

    return [subId,opacityMap];

  }));



  const [ src, setSrc ] = useState();

  return (
    <>
      {false&&<pre> {JSON.stringify(valsBySubMap,null,1)} </pre>}
      <div onMouseLeave={() => setHover({gridId:null,pos:[-1,-1]})} id={GRID_DOM_ID}>
    {grid.map((row,ii) => {
        return (
          <div class="sg-row v-center">
            {showHeadings && <div class="sg-row" style={{lineHeight:0.7, 
              fontSize:28,
              width:30
            }}>
              <b>{alpha[ii]}</b>
            </div>
            }
            {row.map((col,jj) => {
              return (
                <PlateWell {...{setHover, row:ii, col:jj, hoverMap,
                  substanceOpacityMap:valsBySubMap,
                  onClick:(e) => onClick(e,{row:ii,col:jj}),
                  cell:col,
                  experiment,
                  gridId,
                  showText,
                }} />
              )
            })}
          </div>
        )
      })}
    </div>
      <img src={src}/ >
    </>
  )
}
